function closeNavigation( object ) {

	var $this = $( object );
	$( '.menu-item' ).removeClass( 'focus' );

	if ( $this.hasClass( 'search' ) ) {
		$this.addClass( 'focus' );
	}
}

(function($) {

	var $primaryMenu = $("#primary-menu");

	var $searchBar = $(".search-bar");
	var $searchPreview = $searchBar.find("#search-preview");
	var $button = $searchBar.find(".button");
	var $runSearch = $searchBar.find(".run-search");

	// $("#close-search").on("click", function() {

	// 	$primaryMenu.addClass("hovers");

	// 	$searchBar.removeClass("is-active");
	// 	$searchPreview.empty();
	// 	$button.removeClass("is-visible");
	// 	$searchBar.find(".search-field").val("");

	// 	//Hide the menus if visible and content is clicked upon
	// 	if($('.menu-item').hasClass('focus')){
	// 		closeNavigation();
	// 	}
	// });

	function ldcSiteSearchQueryIsEmpty(form) {
		if (!form) {
			return true;
		}
		var input = form.querySelector('.search-field, .site-search-refine__field, input[name="s"]');
		return !input || input.value.trim() === '';
	}

	function ldcGuardEmptySiteSearch(form) {
		if (!form || form.getAttribute('data-empty-search-guard') === '1') {
			return;
		}
		if (form.querySelector('input[name="searchfilter"]')) {
			return;
		}
		form.setAttribute('data-empty-search-guard', '1');
		form.addEventListener('submit', function (event) {
			if (!ldcSiteSearchQueryIsEmpty(form)) {
				return;
			}
			event.preventDefault();
			var input = form.querySelector('.search-field, .site-search-refine__field, input[name="s"]');
			if (input) {
				input.focus();
			}
		});
	}

	$($runSearch).on("click", function(event) {
		event.preventDefault();
		var form = $(this).closest('form.search-form').get(0);
		if (ldcSiteSearchQueryIsEmpty(form)) {
			var input = form ? form.querySelector('.search-field') : null;
			if (input) {
				input.focus();
			}
			return;
		}
		form.submit();
	});

	document.querySelectorAll('form.search-form, form.site-search-refine').forEach(ldcGuardEmptySiteSearch);

	document.querySelectorAll('[data-search-suggestions="popular"]').forEach(function (panel) {
		if (panel.getAttribute('data-search-suggestions-persist') === '1') {
			return;
		}
		var form = panel.closest('form');
		var input = form ? form.querySelector('.search-field') : null;
		if (!input) {
			return;
		}
		function sync() {
			panel.hidden = input.value.trim() !== '';
		}
		input.addEventListener('input', sync);
		input.addEventListener('search', sync);
		sync();
	});

	$searchBar.find(".search-formDISABLE").on("submit", function(event) {
		//disabled for now
		event.preventDefault();
		var query = $(this)
			.find(".search-field")
			.val();
		$.ajax({
			type: "POST",
			url: ldc_ajax_object.ajax_url,
			dataType: "html", // add data type
			data: {
				action: "ldc_relevanssi_do_query",
				security: ldc_ajax_object.security,
				query: query
			},

			success: function(response) {
				var searchResults = JSON.parse(response);
				if (undefined !== response.success && false === response.success) {
					return;
				}
				$searchPreview.empty();
				$.each(searchResults, function(index, searchResult) {
					$searchPreview.append(
						'<div class="search-result">' +
							'<a href="' +
							searchResult.link +
							'">' +
							'<p class="title">' +
							searchResult.title +
							"</p>" +
							'<p class="excerpt">' +
							searchResult.excerpt +
							"</p>" +
							'<div class="read-more">' +
							'<img class="read-more-arrow" src="' +
							location.origin +
							'/wp-content/themes/ldc-2023/dist/images/arrow-tall.svg">' +
							'<img class="read-more-text" src="' +
							location.origin +
							'/wp-content/themes/ldc-2023/dist/images/read-more.svg">' +
							"</div>" +
							"</a>" +
							"</div>"
					);
				});
				$button.addClass("is-visible");
				$button.attr("href", location.origin + "?s=" + query);
			},
			error: function(error) {
			}
		});
	});
})(jQuery);
